import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { TabsComponent } from './tabs.component';

const routes: Routes = [
  {
    path: '',
    component: TabsComponent,
    children: [
      {
        path: 'competitions',
        loadChildren: () => import('./competitions/competitions.module').then(m => m.CompetitionsPageModule)
      },
      {
        path: 'stats',
        loadChildren: () => import('./stats/stats.module').then( m => m.StatsPageModule)
      },
      {
        path: 'rankoverview',
        loadChildren: () => import('./rankoverview/rankoverview.module').then( m => m.RankoverviewPageModule)
      },

      {
        path: '',
        redirectTo: '/competitions',
        pathMatch: 'full'
      }    
    ]
  },
  {
    path: '',
    redirectTo: '/competitions',
    pathMatch: 'full'
  },
  {
    path: 'athletesearch',
    loadChildren: () => import('./athletesearch/athletesearch.module').then( m => m.AthletesearchPageModule)
  },
  {
    path: 'ics',
    loadChildren: () => import('./ics/ics.module').then( m => m.IcsPageModule)
  },
  {
    path: 'competition',
    loadChildren: () => import('./competition/competition.module').then( m => m.CompetitionPageModule)
  },
  {
    path: 'competition-search',
    loadChildren: () => import('./competition-search/competition-search.module').then( m => m.CompetitionSearchPageModule)
  },
  {
    path: 'rankings',
    loadChildren: () => import('./rankings/rankings.module').then( m => m.RankingsPageModule)
  },
  {
    path: 'stats/competitions',
    loadChildren: () => import('./stats/competitions/competitions.module').then( m => m.CompetitionsPageModule)
  },
  {
    path: 'stats/countries',
    loadChildren: () => import('./stats/countries/countries.module').then( m => m.CountriesPageModule)
  },
  {
    path: 'country',
    loadChildren: () => import('./country/country.module').then( m => m.CountryPageModule)
  },
  {
    path: 'stats/medallists',
    loadChildren: () => import('./stats/medallists/medallists.module').then( m => m.MedallistsPageModule)
  },
  {
    path: 'stats/athlete-progress-comparison',
    loadChildren: () => import('./stats/athlete-progress-comparison/athlete-progress-comparison.module').then( m => m.AthleteProgressComparisonPageModule)
  },
  {
    path: 'medaltable',
    loadChildren: () => import('./medaltable/medaltable.module').then( m => m.MedaltablePageModule)
  },
  {
    path: 'privacypolicy',
    loadChildren: () => import('./privacypolicy/privacypolicy.module').then( m => m.PrivacypolicyPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
